module.exports = __webpack_public_path__ + "img/product_img1.bc1f9df4.png";